import React, { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import './AddMySQL.css';
import axios from './axiosConfig';

const AddMySQL: React.FC = () => {
    const [name, setName] = useState("");
    const [host, setHost] = useState("");
    const [port, setPort] = useState(3306);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [database, setDatabase] = useState("");
    const [secure, setSecure] = useState(false);
    const [errors, setErrors] = useState({ name: "", host: "", port: "", username: "", password: "", database: "" });

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        const newErrors = { name: "", host: "", port: "", username: "", password: "", database: "" };
        if (!name) newErrors.name = "Name is required";
        if (!host) newErrors.host = "Host is required";
        if (!port) newErrors.port = "Port is required";
        if (!username) newErrors.username = "Username is required";
        if (!password) newErrors.password = "Password is required";
        if (!database) newErrors.database = "Database name is required";

        setErrors(newErrors);

        if (!name || !host || !port || !username || !password || !database) {
            console.log('Validation failed', newErrors);
            return;
        }

        const dataSource = {
            name,
            type: 'MySQL',
            host,
            port,
            username,
            password,
            database,
            secure
        };

        console.log('Data source:', dataSource);

        try {
            const response = await axios.post('/api/data-sources', dataSource);
            if (response.status === 200) {
                console.info('Add data source completed', response.data);
                setErrors({ name: "", host: "", port: "", username: "", password: "", database: "" }); // Clear errors on successful submission
            } else {
                console.error('Failed to add user', response.data);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <Container>
            <h1 className="my-4">MySQL</h1>
            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="connectionSettings" className="mb-3">
                    <Form.Label>Connection</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Host URL"
                        value={host}
                        onChange={(e) => setHost(e.target.value)}
                        className={`mb-2 uniform-width ${errors.host ? 'is-invalid' : ''}`}
                    />
                    {errors.host && <div className="invalid-feedback">{errors.host}</div>}

                    <Form.Control
                        type="number"
                        placeholder="Port"
                        value={port}
                        onChange={(e) => setPort(Number(e.target.value))}
                        className={`mb-2 uniform-width ${errors.port ? 'is-invalid' : ''}`}
                    />
                    {errors.port && <div className="invalid-feedback">{errors.port}</div>}
                </Form.Group>

                <Form.Group controlId="authenticationSettings" className="mb-3">
                    <Form.Label>Authentication</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        className={`mb-2 uniform-width ${errors.name ? 'is-invalid' : ''}`}
                    />
                    {errors.name && <div className="invalid-feedback">{errors.name}</div>}

                    <Form.Control
                        type="text"
                        placeholder="Database name"
                        value={database}
                        onChange={(e) => setDatabase(e.target.value)}
                        className={`mb-2 uniform-width ${errors.database ? 'is-invalid' : ''}`}
                    />
                    {errors.database && <div className="invalid-feedback">{errors.database}</div>}

                    <Form.Control
                        type="text"
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        className={`mb-2 uniform-width ${errors.username ? 'is-invalid' : ''}`}
                    />
                    {errors.username && <div className="invalid-feedback">{errors.username}</div>}

                    <Form.Control
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className={`mb-2 uniform-width ${errors.password ? 'is-invalid' : ''}`}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                </Form.Group>

                <Row className="mb-3">
                    <Col>
                        <Button variant="primary" type="submit" className="w-100">Save & Test</Button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}

export default AddMySQL;
